import { getSiteDictionary, type SiteDictionary } from '@/content/i18n/site';
import { TOOL_SLUGS } from '@/content/tools';
import { localizedPath, useLocale, type Locale } from '@/lib/i18n';

/**
 * The page's language and its site strings, plus a link helper that keeps a
 * visitor inside their language where a translation exists and falls back to
 * the English page where it does not (blog, legal, the app).
 */
export function useSite(): { locale: Locale; s: SiteDictionary; path: (p: string) => string } {
  const locale = useLocale();
  return { locale, s: getSiteDictionary(locale), path: (p) => localizedPath(locale, p, TOOL_SLUGS) };
}

export const sitePath = (locale: Locale, p: string): string => localizedPath(locale, p, TOOL_SLUGS);
